import { createStore } from "redux";
import { provider } from "react-redux"
import clientReducer from "./reducers/clientReducer";



const store = createStore(clientReducer)

export default store;